export enum IfGateInOptions {
	ArrayField,
	FixedValues,
}
